/**
 * Custom JavaScript to hide Shiprocket powered-by elements
 */
(function() {
  // Function to hide sr-powered-by elements
  function hidePoweredByElements() {
    // Find all elements with class containing 'sr-powered-by'
    const poweredByElements = document.querySelectorAll('[class*="sr-powered-by"]');
    
    if (poweredByElements.length > 0) {
      poweredByElements.forEach(element => {
        element.style.display = 'none';
        element.style.visibility = 'hidden';
        element.style.opacity = '0';
        element.style.height = '0';
        element.style.width = '0';
        element.style.overflow = 'hidden';
        element.style.position = 'absolute';
      });
    }
  }

  // Run immediately
  hidePoweredByElements();

  // Set up a MutationObserver to watch for new elements
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        // Check if any added nodes contain sr-powered-by elements
        hidePoweredByElements();
      }
    });
  });

  // Start observing the document with the configured parameters
  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });

  // Also run on DOMContentLoaded and window load events
  document.addEventListener('DOMContentLoaded', hidePoweredByElements);
  window.addEventListener('load', hidePoweredByElements);
  
  // Run periodically to catch any elements that might be added dynamically
  setInterval(hidePoweredByElements, 1000);
})();